import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';

const columns = [
  { field: 'id', headerName: 'ID', width: 70 },
  { field: 'leaveType', headerName: 'Leave Type', width: 130 },
  {
    field: 'leaveBalance',
    headerName: 'Balance Leave',
    type: 'number',
    width: 130
  },
];

const rows = [
  { id: 1, leaveType: 'Medical', leaveBalance: 3},
];

export default function LeaveBalanceTable() {
  return (
    <div style={{ height: 400, width: 500 }}>
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[5]}
      />
    </div>
  );
}
